export const get_currencies = `query get_currencies($type: CurrencyType!, $list_type: CurrencyListType!, $account: String!){
    get_currencies(type: $type, list_type: $list_type, account: $account){
        currency
        name
        decimal
    }
}`;
